module.exports = __webpack_public_path__ + "img/performance-no-data.5c21dd6f.png";